import React, { useEffect, useState } from "react"
import { Tab, Tabs } from "react-bootstrap"
import StageAnswers from "./StageAnswers"
import axios from "axios"

const StagesTable = ({ pStageID, stageID, setAuth }) => {
  const [sections, setSections] = useState([])
  console.log("sections", sections)

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      StageID: stageID,
      // ProjectID: projectId,
    }

    axios
      .post(process.env.REACT_APP_API_URL+"api/Sections/View", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        // console.log("res", res)
        let array = Object.values(res.data)
        array.splice(-1)
        setSections(array)
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  return (
    <div>
      {sections.length > 0 && (
        <Tabs className="mb-3" justify fill>
          {sections.map((section, i) => (
            <Tab
              key={i}
              eventKey={section.SectionName}
              title={section.SectionName}
            >
              {/* {section.SectionName} */}
              <StageAnswers section={section} pStageID={pStageID} />
            </Tab>
          ))}
        </Tabs>
      )}
    </div>
  )
}

export default StagesTable
